import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { Navigation, Footer, Home, Aboutus, Brandingandgraphicdesign, Signageoutdoor, Signageindoor, Signageindustrial, Digitalsignage, Printingservices, Eventservices, Exhibitionservices, Corporateservices, Webdesignservices, Socialmediamarketing, Tradingservices, Projects, Facility, Certificates, Qualitypolicy, Clients, Jobs, Contact, Privacypolicy, ITsolutions, Corevalues } from "./components";
import Pageloader from "./components/Pageloader";
import AOS from 'aos';
// import 'aos/dist/aos.css';
import "./assets/css/style.css";
import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./../node_modules/bootstrap/dist/js/bootstrap.min.js";

AOS.init();

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000); 
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Pageloader />;
  }

  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Aboutus" element={<Aboutus />} />
        <Route path="/Brandingandgraphicdesign" element={<Brandingandgraphicdesign />} />
        <Route path="/Signageoutdoor" element={<Signageoutdoor />} />
        <Route path="/Signageindoor" element={<Signageindoor />} />
        <Route path="/Signageindustrial" element={<Signageindustrial />} />
        <Route path="/Digitalsignage" element={<Digitalsignage />} />
        <Route path="/Printingservices" element={<Printingservices />} />
        <Route path="/Eventservices" element={<Eventservices />} />
        <Route path="/Exhibitionservices" element={<Exhibitionservices />} />
        <Route path="/Corporateservices" element={<Corporateservices />} />
        <Route path="/Webdesignservices" element={<Webdesignservices />} />
        <Route path="/Socialmediamarketing" element={<Socialmediamarketing />} />
        <Route path="/Tradingservices" element={<Tradingservices />} />
        <Route path="/Projects" element={<Projects />} />
        <Route path="/Facility" element={<Facility />} />
        <Route path="/Certificates" element={<Certificates />} />
        <Route path="/Qualitypolicy" element={<Qualitypolicy />} />
        <Route path="/Clients" element={<Clients />} />
        <Route path="/Jobs" element={<Jobs />} />
        <Route path="/Contact" element={<Contact />} />    
        <Route path="/Privacypolicy" element={<Privacypolicy />} />
        <Route path="/ITsolutions" element={<ITsolutions />} />
        <Route path="/Corevalues" element={<Corevalues />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </Router>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);




// All Page Loader Start

// import React, { useState, useEffect } from "react";
// import ReactDOM from "react-dom";
// import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
// import { Navigation, Footer, Home, Aboutus, Brandingandgraphicdesign, Signageoutdoor, Signageindoor, Signageindustrial, Printingservices, Eventservices, Exhibitionservices, Corporateservices, Webdesignservices, Socialmediamarketing, Tradingservices, Projects, Facility, Qualitypolicy, Clients, Jobs, Contact, Branding1 } from "./components";
// import Pageloader from "./components/Pageloader";
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import "./assets/css/style.css";
// import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
// import "./../node_modules/bootstrap/dist/js/bootstrap.min.js";

// AOS.init();

// const App = () => {
//   const [loading, setLoading] = useState(true);
//   const location = useLocation(); 

//   useEffect(() => {
//     const timer = setTimeout(() => setLoading(false), 1500); 
//     setLoading(true); 
//     return () => clearTimeout(timer);
//   }, [location]); 

//   if (loading) {
//     return <Pageloader />;
//   }

//   return (
//     <div>
//       <Navigation />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/aboutus" element={<Aboutus />} />
//         <Route path="/brandingandgraphicdesign" element={<Brandingandgraphicdesign />} />
//         <Route path="/signageoutdoor" element={<Signageoutdoor />} />
//         <Route path="/signageindoor" element={<Signageindoor />} />
//         <Route path="/signageindustrial" element={<Signageindustrial />} />
//         <Route path="/printingservices" element={<Printingservices />} />
//         <Route path="/eventservices" element={<Eventservices />} />
//         <Route path="/exhibitionservices" element={<Exhibitionservices />} />
//         <Route path="/corporateservices" element={<Corporateservices />} />
//         <Route path="/webdesignservices" element={<Webdesignservices />} />
//         <Route path="/Socialmediamarketing" element={<Socialmediamarketing />} />
//         <Route path="/tradingservices" element={<Tradingservices />} />
//         <Route path="/projects" element={<Projects />} />
//         <Route path="/facility" element={<Facility />} />
//         <Route path="/qualitypolicy" element={<Qualitypolicy />} />
//         <Route path="/clients" element={<Clients />} />
//         <Route path="/jobs" element={<Jobs />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/branding1" element={<Branding1 />} />
//         <Route path="*" element={<Navigate to="/" />} />
//       </Routes>
//       <Footer />
//     </div>
//   );
// };

// ReactDOM.render(
//   <React.StrictMode>
//     <Router>
//       <App />
//     </Router>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

